import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const MegaWarehouse = (props) => {
  return (
    <SvgIcon viewBox="0 0 72 72" {...props}>
      <path
        className="icon-accent"
        d="M24 60V42H36V36H42V48H48V60H24Z"
        fill="#ACADB1"
      />
      <path
        className="icon-main"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.2184 9.25857C36.4427 8.91381 35.5573 8.91381 34.7816 9.25857L7.78158 21.2586C6.6982 21.7401 6 22.8144 6 24V63C6 64.6569 7.34315 66 9 66C10.6569 66 12 64.6569 12 63V25.9496L36 15.283L60 25.9496V63C60 64.6569 61.3431 66 63 66C64.6569 66 66 64.6569 66 63V24C66 22.8144 65.3018 21.7401 64.2184 21.2586L37.2184 9.25857ZM46.2426 31.7574C45.1174 30.6321 43.5913 30 42 30H36C34.4087 30 32.8826 30.6321 31.7574 31.7574C30.6321 32.8826 30 34.4087 30 36H21C19.3431 36 18 37.3431 18 39V63C18 64.6569 19.3431 66 21 66H51C52.6569 66 54 64.6569 54 63V45C54 43.3431 52.6569 42 51 42H48V36C48 34.4087 47.3679 32.8826 46.2426 31.7574ZM48 48H36V60H48V48ZM30 60H24V42H30V60ZM36 36H42V42H36V36Z"
        fill="#63656E"
      />
    </SvgIcon>
  );
};

export default MegaWarehouse;
